// extracted by mini-css-extract-plugin
export default {"wrapper":"B9n0h","btn":"dqbJF"};